module.exports = __webpack_public_path__ + "components/outside-promo-page/static/app-11d2db0742889570fd41a1a94c111bc3.png";